import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ZipcodeResponse } from '../model/zipcode-response';
import { ZipcodeErrorCode } from '../model/zipcode-error-code';
import { validarCEP } from '../utils';
import { ZipcodeError } from '../model/zipcode-error';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AddressService {
  constructor(private http: HttpClient) {}

  private peopleDataSubject = new BehaviorSubject<any>(null);

  private apiUrl = environment.apiUrl;

  getAddressByPeopleId(peopleId: string): Observable<any> {
    const url = `${this.apiUrl}/sicred/api/v1/address/filtered?cpf=${peopleId}`; // URL correta da API
    return this.http.get(url, { withCredentials: true });
  }

  getAddressById(addressId: number): Observable<any> {
    const url = `${this.apiUrl}/sicred/api/v1/address/id/${addressId}`; // URL correta da API
    return this.http
      .get<any>(url , { withCredentials: true })
      .pipe(catchError(this.handleError));
  }

  getAddressByZipcode(zipcode: string): Observable<ZipcodeResponse> {

    return of(zipcode).pipe(
      validarCEP(),
      switchMap((validZipcode) =>
        this.http.get<ZipcodeResponse>(
          `${this.apiUrl}/sicred/api/v1/address/cep/${validZipcode}`, { withCredentials: true }
        )
      ),
      map((endereco) => {
        if ('cep' in endereco) {
          return endereco;
        }
        throw new ZipcodeError(ZipcodeErrorCode.CEP_NAO_ENCONTRADO);
      })
    );
  }

  setAddressData(addressId: number, addressData: any): Observable<any> {
    const url = `${this.apiUrl}/sicred/api/v1/address/update/${addressId}`; // URL correta da API
    return this.http.put(url, addressData, {withCredentials: true} );
  }

  /**
   * Tratamento de erros de HTTP
   * @param error - Erro HTTP
   * @returns Observable com o erro tratado
   */
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Ocorreu um erro inesperado.';

    if (error.error instanceof ErrorEvent) {
      // Erro no lado do cliente
      errorMessage = `Erro: ${error.error.message}`;
    } else {
      // Erro no lado do servidor
      errorMessage = `Erro ${error.status}: ${error.message}`;
    }

    console.error(errorMessage); // Log opcional
    return throwError(() => new Error(errorMessage));
  }
}
